<script lang="ts">
  import { onMount } from "svelte"
  import Navigation from "./Navigation.svelte"
  import Honeybadger from "$app/utils/honeybadger"
  import bg from "@images/onboarding/bg-eclipse.jpg"
  import Goal from "./components/Goal.svelte"
  import { xhr, toast } from "$app/utils"
  import PrevNextSkipButtons from "$app/Pages/Plans/Onboarding/components/PrevNextSkipButtons.svelte"
  import LoadingSpinner from "$app/components/LoadingSpinner.svelte"
  import { onboardingStore } from "./onboarding.svelte"
  import { appStore } from "$app/store.svelte"

  let long_term_goal: GoalType = {} as GoalType
  let annual_goal: GoalType = {} as GoalType
  let quarterly_goal: GoalType = {} as GoalType
  let task: TaskType = {} as TaskType

  let loading = false
  async function getGoalsAndTask(): Promise<void> {
    loading = true
    try {
      const resp = await xhr.get(
        `/plan_onboarding/${appStore.plan.id}/get_goals.json?goal_type=task`
      )

      long_term_goal = resp.data.long_term_goal
      annual_goal = resp.data.annual_goal
      quarterly_goal = resp.data.quarterly_goal
      task = resp.data.task
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error loading your goals", "error")
    } finally {
      loading = false
    }
  }

  onboardingStore.completed = true

  onMount(() => {
    onboardingStore.setBrowserHistory({}, "goal_review")
    getGoalsAndTask()
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step={onboardingStore.current_onboarding_step} on:updateStep />

    <div class="px-4 w-full lg:w-1/2 xl:pr-16">
      <h2 class="mt-12 text-5xl font-bold text-center text-white">
        Goals Review
      </h2>
      <h3 class="mt-4 text-2xl text-white mb-8">
        You have successfully created the first goal hierarchy of your plan!
        From the top-level Long-Term goal, down to an individual Task.
      </h3>

      <p class="mt-8 text-white text-lg">
        In Lead With Purpose, Goals and Tasks are all organized within a
        hierarchical structure with the Long-Term goals at the top. As you
        continue to build out your plan, we recommend that you create 4 or 5
        Long-Term Goals. Under each of your Long-Term Goals you will then build
        out your Annual Goals, Quarterly Goals and Tasks.
      </p>
      <p class="mt-8 text-white text-lg">
        Once you complete this Onboarding experience, you can continue to build
        out your goals by clicking on Goals in the top-level menu and then
        clicking on the "By Hierarchy" tab where you can view and edit your
        entire goal hierarchy.
      </p>

      <PrevNextSkipButtons />
    </div>
  </div>
</div>

<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-32 lg:-mb-32 rounded-tl-lg lg:-right-0 md:w-1/3 lg:w-1/2 bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
  style="background-image: url({bg})"
>
  {#if loading}
    <LoadingSpinner />
  {:else}
    <div class="scale-75">
      <div style="transform: translateX(-100px)">
        <h2 class="text-2xl pb-4 font-semibold text-gray-600">
          {appStore.plan.name} goals
        </h2>

        <ul class="hierarchy">
          <li>
            <Goal name={long_term_goal.name} goalType="long_term_goal" />
            <ul>
              <li>
                <Goal name={annual_goal.name} goalType="annual_goal" />
                <ul>
                  <li>
                    <Goal
                      name={quarterly_goal.name}
                      goalType="quarterly_goal"
                    />
                    <ul>
                      <li>
                        <Goal name={task.name} goalType="task" />
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  {/if}
</div>
